/* BBWF: first "Load more reviews" tap on mobile reveals the hidden reviews; later taps fall through to Yotpo */
(function () {
  document.addEventListener('click', function (e) {
    if (window.innerWidth > 749) return;
    if (document.body.classList.contains('bbwf-reviews-expanded')) return;
    var btn = e.target.closest && e.target.closest('.yotpo-reviews-main-widget .yotpo-vertical-pagination-item');
    if (!btn) return;
    var list = document.querySelector('.yotpo-reviews-main-widget .yotpo-reviews-cart-list');
    if (list && list.children.length > 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.body.classList.add('bbwf-reviews-expanded');
    }
  }, true);
})();